export const RECALCULATE_CHAT_WIDGET_POSITION = 'RECALCULATE_LAUNCHER_POSITION';

export function triggerChatWidgetPositionCalculation() {
  window.dispatchEvent(new CustomEvent(RECALCULATE_CHAT_WIDGET_POSITION));
}
